import { ArrowLeftOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { BackButton, TitleWrapper, Wrapper } from './PageTitleStyled'

const PageTitle = ({ ...props }) => {
  const {
    title,
    marginBottom,
    marginTop,
    children,
    location,
    showTitle,
    status,
    routerGoBack,
    hiddenGoBack,
    customBreadcrumb,
  } = props

  let history = useHistory()

  const renderTitle = string => {
    if (string) {
      if (string.length <= 90) return string
      return (
        <Tooltip title={string}>
          {string.substring(0, 90).concat('...')}
        </Tooltip>
      )
    }
  }

  return (
    <>
      <Wrapper marginBottom={marginBottom} marginTop={marginTop}>
        {customBreadcrumb ? customBreadcrumb : <div />}
        {children}
      </Wrapper>
      {showTitle && (
        <div className="pageHeaderWrapper" style={{ marginBottom: 12, justifyContent: 'flex-start' }}>
          {!hiddenGoBack && (
            <BackButton
              style={{ transform: 'none' }}
              onClick={() =>
                routerGoBack ? history.push(routerGoBack) : history.goBack()
              }>
              <ArrowLeftOutlined />
            </BackButton>
          )}
          <h1 className={`pageTitle ${status ? 'pageTitleWithStatus' : ''}`}>
            {renderTitle(title)}
            {status && <span>{status}</span>}
          </h1>
        </div>
      )}
    </>
  )
}

PageTitle.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  marginBottom: PropTypes.number,
  marginTop: PropTypes.number,
  color: PropTypes.string,
  customBreadcrumb: PropTypes.node,
}

export default PageTitle
